import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PermissionApiDTO, PermissionApiResponse } from '../dto/permission.api.dto';
import { PermissionGroupApiDTO, PermissionGroupApiResponse } from '../dto/permission-group.api.dto';

@Injectable({ providedIn: 'root' })
export class PermissionGateway {
  private readonly http = inject(HttpClient);

  getPermissions(): Observable<PermissionApiDTO[]> {
    const apiUrl = `${environment.apiURL}/api/v2/permissions/search`;

    return this.http.get<PermissionApiResponse>(apiUrl, {}).pipe(
      map(response => response?.data || [])
    );
  }

  getPermissionGroups(organizationId: string): Observable<PermissionGroupApiDTO[]> {
    const apiUrl = `${environment.apiURL}/api/v2/permission-groups/search`;

    const params = new HttpParams()
      .set('organizationId', organizationId)
      .set('orderBy', 'name')
      .set('orderType', 'asc');

    return this.http.get<PermissionGroupApiResponse>(apiUrl, { params }).pipe(
      map(response => response?.data || [])
    );
  }
}